/* @flow */

import React from 'react';
import {useParams} from 'react-router-dom';

import SellerInvoiceDetailsComponent from 'app/sellers/invoiceDetails';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function SellerInvoiceDetailsPage() {
  const {id} = useParams();

  return (
    <WebsitePageComponent noPaper noTitle>
      <SellerInvoiceDetailsComponent invoiceId={id} />
    </WebsitePageComponent>
  );
}
